import { render, staticRenderFns } from "./PublicOrderFeedback.vue?vue&type=template&id=dd8585f4&scoped=true&"
import script from "./PublicOrderFeedback.vue?vue&type=script&lang=js&"
export * from "./PublicOrderFeedback.vue?vue&type=script&lang=js&"
import style0 from "./PublicOrderFeedback.vue?vue&type=style&index=0&id=dd8585f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8585f4",
  null
  
)

export default component.exports